/**
 * Sunucudan `arraybuffer` olarak gelen dosyayı tarayıcıya kaydettirir.
 *
 * Aynı fonksiyon iki rapor ekranında birebir kopyalanmıştı; dosya adındaki
 * zaman damgası da dahil tek yerde toplandı.
 */
export const downloadBlobFile = (
  data: any,
  namePrefix: string,
  extension: string = "xlsx"
) => {
  const stamp = new Date();
  const pad = (value: number) => String(value).padStart(2, "0");
  const filename =
    `${namePrefix}-${stamp.getFullYear()}${pad(stamp.getMonth() + 1)}` +
    `${pad(stamp.getDate())}-${pad(stamp.getHours())}${pad(stamp.getMinutes())}` +
    `.${extension}`;

  const url = URL.createObjectURL(new Blob([data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
